import React from "react";

import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";
import {
  GetMessage
} from '../../variables/message'

export default class AlertModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            title: 'エラー',
            error_message:'',
            confirm:undefined,
            cancel:true,
            titleBtn: "",
        };
        this.toggleErrorModal = this.toggleErrorModal.bind(this)
        this.closeErrorModal = this.closeErrorModal.bind(this)
        this.showErrorModal = this.showErrorModal.bind(this)
        this.confirmCheck = this.confirmCheck.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    showErrorModal({message = '未知のエラーが発生しました', title='エラー', messageNo}) {
      if (this.state.error_modal){
        return
      }
      if (messageNo){
        const message = GetMessage(messageNo)
        this.setState({
          error_message: message,
          title:title,
          error_modal:true,
          confirm:undefined,
          closeBtn:true
        });
      } else {
        this.setState({
          error_message: message,
          title:title,
          error_modal:true,
          confirm:undefined,
          closeBtn:true
        });
      }
    }

    confirmCheck({message = '確認してください。', title='確認', messageNo, closeBtn=true, titleBtn=""}, callback, cancel=true) {

      if (this.state.error_modal){
        return
      }
      if (messageNo){
        const message = GetMessage(messageNo)
        this.setState({
          error_message: message,
          title:title,
          error_modal:true,
          confirm:callback,
          cancel,
          closeBtn:closeBtn,
          titleBtn:titleBtn
        });
      } else {
        this.setState({
          error_message: message,
          title:title,
          error_modal:true,
          confirm:callback,
          cancel,
          closeBtn:closeBtn,
          titleBtn:titleBtn
        });
      }
    }

    toggleErrorModal(){
      this.setState({
        error_modal: !this.state.error_modal,
        confirm:undefined
      });
    }

    closeErrorModal(){
      this.setState({
        error_modal: false,
        confirm:undefined
      });
    }

    componentDidMount() {
      document.addEventListener("keydown", this.handleKeyDown);
    }
    handleKeyDown(e) {
      const escKey = e.keyCode === 27;
      const {confirm} = this.state
      if (escKey) {
        if(confirm){
          confirm();
        }else{
          this.closeErrorModal();
        }
      }
    }


    render() {
      const {
        confirm,
        cancel,
        closeBtn
      } = this.state

      return (
        <>
        <div id="requestErrorModal"></div>
        <Modal isOpen={this.state.error_modal} toggle={this.toggleErrorModal} backdrop="static">
        <div className="modal-header">
          {closeBtn?<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeErrorModal}>
            <i className="tim-icons icon-simple-remove"></i>
          </button>:""}
          <h5 className="modal-title">{this.state.title != "" ? this.state.title : confirm?'確認':''}</h5>
        </div>
        <ModalBody>
          <p dangerouslySetInnerHTML={{__html:this.state.error_message}}></p>
        </ModalBody>
        <ModalFooter>
          {cancel&&<Button color="secondary" onClick={this.closeErrorModal}>
            {confirm?'いいえ':'閉じる'}
          </Button>}
          {confirm&&
            <Button color="info" onClick={()=>{confirm(); this.closeErrorModal()}}>
              {this.state.titleBtn != "" ? this.state.titleBtn : cancel?"はい":"OK"}
            </Button>
          }
        </ModalFooter>
      </Modal>
      </>
      );
    }
}

